import {
	LookupModel,
	IdentityDocumentTypesEnum,
	AddressDocumentTypesEnum,
	DocumentTypesEnum,
	IndividualExtendedModel, AddressTypesEnum
} from '@spa/api';

import {Language} from '../../language';
import {CountryCodesEnum} from "../../../pages/portal/enums";

export class EnumsHelper {
	protected constructor() {
	}

	static isIndividualBulgariaResident(individual: IndividualExtendedModel) : boolean {
		return  individual.getAddressByType(AddressTypesEnum.Residential)?.countryId == CountryCodesEnum.Bulgaria;
	}

	static isProofOfIdentityIsDrivingLicense(individual: IndividualExtendedModel) : boolean {
		return individual.identityDetails?.find(i => i.identityDocumentType === IdentityDocumentTypesEnum.DrivingLicense) != null;
	}

	static isProofOfIdentityIsIdentityCard(individual: IndividualExtendedModel) : boolean {
		return individual.identityDetails?.find(i => i.identityDocumentType === IdentityDocumentTypesEnum.IdentityCard) != null;
	}

	static getVerificationDocumentTypes(): DocumentTypesEnum[] {
		return [
			DocumentTypesEnum.CertificateOfIncorporation,
			DocumentTypesEnum.CertificateOfCurrentStanding,
			DocumentTypesEnum.ArticleOfAssociation,
			DocumentTypesEnum.MemorandumOfAssociation,
			DocumentTypesEnum.RegisterOfDirectors,
			DocumentTypesEnum.RegisterOfShareholders,
			DocumentTypesEnum.ProofOfIdentity
		]
	}

	static getDocumentTypes(currentLanguage: string): LookupModel {
		return new LookupModel({
			[DocumentTypesEnum.ProofOfIdentity]: currentLanguage === Language.English ? 'Proof of identity' : 'Документ за самоличност',
			[DocumentTypesEnum.ProofOfAddress]: currentLanguage === Language.English ? 'Proof of address' : 'Документи за доказване на адреса по местоживеене',
			[DocumentTypesEnum.Selfie]: currentLanguage === Language.English ? 'Selfie' : 'Селфи',
			[DocumentTypesEnum.Other]: currentLanguage === Language.English ? 'Other' : 'Друг',
		});
	}

	static getProofOfIdentityDocumentTypes(currentLanguage: string, addDrivingLicense = true): LookupModel {
		if (addDrivingLicense) {
			return new LookupModel({
				[IdentityDocumentTypesEnum.Passport]: (currentLanguage === Language.English) ? 'Passport' : 'Паспорт',
				[IdentityDocumentTypesEnum.IdentityCard]: (currentLanguage === Language.English) ? 'Identity card' : 'Лична карта',
				[IdentityDocumentTypesEnum.DrivingLicense]: (currentLanguage === Language.English) ? 'Driving license' : 'Свидетелство за управление на МПС'
			});
		}

		return new LookupModel({
			[IdentityDocumentTypesEnum.Passport]: (currentLanguage === Language.English) ? 'Passport' : 'Паспорт',
			[IdentityDocumentTypesEnum.IdentityCard]: (currentLanguage === Language.English) ? 'Identity card' : 'Лична карта'
		});
	}

	static getProofOfAddressDocumentTypes(currentLanguage: string, addDrivingLicense = false, addIdentityCard = false): LookupModel {
		if (addDrivingLicense) {
			return new LookupModel({
				[AddressDocumentTypesEnum.BankStatement]: (currentLanguage === Language.English) ? 'Bank statement' : 'Банково извлечение',
				[AddressDocumentTypesEnum.UtilityBill]: (currentLanguage === Language.English) ? 'Invoice for electricity, water, telephone' : 'Фактура за ток, вода, телефон',
				[AddressDocumentTypesEnum.DrivingLicense]: (currentLanguage === Language.English) ? 'Driving license' : 'Свидетелство за управление на МПС'
			});
		}

		if (addIdentityCard) {
			return new LookupModel({
				[AddressDocumentTypesEnum.BankStatement]: (currentLanguage === Language.English) ? 'Bank statement' : 'Банково извлечение',
				[AddressDocumentTypesEnum.UtilityBill]: (currentLanguage === Language.English) ? 'Invoice for electricity, water, telephone' : 'Фактура за ток, вода, телефон',
				[AddressDocumentTypesEnum.IdentityCard]: (currentLanguage === Language.English) ? 'Identity card' : 'Лична карта'
			});
		}

		return new LookupModel({
			[AddressDocumentTypesEnum.BankStatement]: (currentLanguage === Language.English) ? 'Bank statement' : 'Банково извлечение',
			[AddressDocumentTypesEnum.UtilityBill]: (currentLanguage === Language.English) ? 'Invoice for electricity, water, telephone' : 'Фактура за ток, вода, телефон'
		});
	}

	static getCompanyDocumentTypes(currentLanguage: string): LookupModel {
		return new LookupModel({
			[DocumentTypesEnum.CertificateOfIncorporation]: currentLanguage === Language.English ? 'Certificate of Incorporation' : 'Удостоверение за вписване в търговски или дружествен регистъ',
			[DocumentTypesEnum.CertificateOfCurrentStanding]: currentLanguage === Language.English ? 'Certificate of Current Standing' : 'Удостоверение за актуално състояние',
			[DocumentTypesEnum.ArticleOfAssociation]: currentLanguage === Language.English ? 'Article of Association' : 'Устав, дружествен договор или друг учредителен акт',
			[DocumentTypesEnum.MemorandumOfAssociation]: currentLanguage === Language.English ? 'Memorandum of Association' : 'Учредителен договор',
			[DocumentTypesEnum.RegisterOfDirectors]: currentLanguage === Language.English ? 'Register of Directors' : 'Регистър на органите на управление и представителств',
			[DocumentTypesEnum.RegisterOfShareholders]: currentLanguage === Language.English ? 'Register of Shareholders' : 'Регистър на акционери или притежатели на дялове',
		});
	}
}
